import angular from 'angular';
import orderRenewalService from '../../services/orderrenewal.service';
import renewalordersListController from './renewalordersList.controller';
import renewalordersListItemController from './renewalordersListItem.controller';

export default angular.module('components.renewalorders', [ orderRenewalService ])
    .component('renewalordersList', {
        template: require('./renewalordersList.pug')(),
        controller: renewalordersListController
    })
    /*
    .component('renewalordersList', {
        template: require('./renewalordersList.pug')(),
        bindings: {
            status: '@'
        }, 
        controller:['$state', 'OrderRenewalService', function($state, OrderRenewalService) {
            var ctrl = this;

            ctrl.$onInit = function() {
                ctrl.$state = $state;
                ctrl.load();
            };

            ctrl.load = function() {
                browse(function(err, response) {
                    if (err) ctrl.error = err.message || err;
                    ctrl.content  = response;
                });
            };

            ////////
            
            function browse(done) {
                OrderRenewalService.get().$promise.then(function(response) {
                    done(null, response);
                }, function(err) {
                    done(err, null);
                });
            }
        }] 
    })
    */
    .component('renewalordersListItem', {
        template: require('./renewalordersListItem.pug')(),
        bindings: {
            item: '<',
            onRemove: '&'
        }, 
        controller: renewalordersListItemController
    })
    /*
    .component('renewalordersListItem', {
        template: require('./renewalordersListItem.pug')(),
        bindings: {
            item: '<',
            onRemove: '&'
        }, 
        controller: ['$state', 'OrderRenewalService', 'RenewalordersConfig', function($state, OrderRenewalService, RenewalordersConfig) {
            var ctrl = this;

            ctrl.$onInit = function() {
                ctrl.$state = $state;
                ctrl.catalogid = RenewalordersConfig.catalogid;
            };

            ctrl.$onChanges = function(changes) {
                if (changes) {
                    ctrl.item = changes.item.currentValue;
                }
            };

            ctrl.remove = function() {
                remove(ctrl.item.uuid, function(err, response) {
                    if (err) ctrl.error = err.message || err;
                    ctrl.content  = response;
                    if (ctrl.onRemove) ctrl.onRemove();
                });
            };

            ////////

            function remove(id, done) {
                OrderRenewalService.remove({id: id}).$promise.then(function(response) {
                    done(null, response);
                }, function(err) {
                    done(err, null);
                });
            }
        }]
    })
    */
    .component('renewalordersSmartButton', {
        template: require('./renewalordersSmartButton.pug')(),
        bindings: {
            text: '@',
            content: '<',
            onDone: '&'
        },
        controller: ['$uibModal', 'OrderRenewalService', function($uibModal, OrderRenewalService) {
            var ctrl = this;
            ctrl.open = function() {
                $uibModal.open({
                    component: "renewalordersSmartButtonModal",
                    resolve: {
                        params: function() {
                            return {
                                text: ctrl.text,
                                content: ctrl.content
                            };
                        }
                    },
                    size: 'lg'
                }).result.then(function(result) {
                    console.info("I was closed, so do what I need to do myContent's controller now.  Result was->" );
                    if (ctrl.onDone) ctrl.onDone();
                }, function(reason) {
                    console.info("I was dimissed, so do what I need to do myContent's controller now.  Reason was->" + reason);
                });
            };
        }]
    })
    .component('renewalordersSmartButtonModal', {
        template: require('./renewalordersSmartButtonModal.pug')(),
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }, 
        controller: ['OrderRenewalService', 'RenewalordersConfig', function(OrderRenewalService, RenewalordersConfig) {
            var ctrl = this;

            ctrl.$onInit = function() {
                ctrl.catalogid = RenewalordersConfig.catalogid;
            };

            ctrl.$onChanges = function(changes) {
                if (changes) {
                    ctrl.content = changes.resolve.currentValue.params.content;
                }
            };

            ctrl.isSuccess = false;
            ctrl.isProcess = false;
            ctrl.isError = false;

            ctrl.approve = function() {
                ctrl.isProcess = true;
                update_status(ctrl.content.uuid, 'APPROVED', function(err, response) {
                    ctrl.response = response;
                    ctrl.isProcess = false;
                    if (err) {
                        ctrl.isError = true;
                    } else {
                        ctrl.isSuccess = true;
                    }
                });
            };

            ctrl.deny = function() {
                ctrl.isProcess = true;
                update_status(ctrl.content.uuid, 'NOT_APPROVED', function(err, response) {
                    ctrl.response = response;
                    ctrl.isProcess = false;
                    if (err) {
                        ctrl.error = err.message || err;
                        ctrl.isError = true;
                    } else {
                        ctrl.isSuccess = true;
                    }
                });
            };

            ctrl.isStatusApproved = function() {
                return ctrl.content.status === 'APPROVED';
            };

            ctrl.isStatusDeny= function() {
                return ctrl.content.status === 'NOT_APPROVED';
            };

            ctrl.isStatusWaitForApproval= function() {
                return ctrl.content.status === 'WAIT_OF_APPROVAL';
            };

            ctrl.ok = function() {
                ctrl.modalInstance.close(ctrl.response);
            };

            ctrl.cancel = function() {
                ctrl.modalInstance.dismiss("cancel");
            };

            ////////
            
            function update_status(id, status,  done) {
                var model = {};

                model.status = status;
                OrderRenewalService.update({id: id}, model).$promise.then(function(response) {
                    done(null, response);
                }, function(err) {
                    done(err, null);
                });
            }

        }]
    })
    .value('RenewalordersConfig', {
        catalogid: 1,
        maxSize: 10,
        hitsList: [
            {name: '1', value: 1},
            //{name: '2', value: 2},
            //{name: '3', value: 3},
            //{name: '4', value: 4},
            {name: '5', value: 5},
            {name: '10', value: 10},
            {name: '20', value: 20}
        ],
        itemsPerPage: 5,
        sortKeysList: [
            {name: __('Sigla (asc)'), value:'sigla:asc'},
            {name: __('Sigla (desc)'), value:'sigla:desc'},
            {name: __('Date (asc)'), value:'ctime:asc'},
            {name: __('Date (desc)'), value:'ctime:desc'},
            {name: __('Record key (asc)'), value:'id:asc'},
            {name: __('Record key (desc)'), value:'id:desc'},
        ]
    })
    .name;
